import * as Html from "../../util/Html.ts";
Html.registerWidget('widget/form/displaycontrolledbyinput',{initDom:initDom})

function initDom(obj: HTMLElement){
  const inputName = obj.getAttribute('data-input');
  if(!inputName) return;

  const form = obj.closest('form');
  if(!form) return;

  const input = form[inputName] as HTMLInputElement;
  if(!input) return;

  function onChange(){
    obj.style.display = input.value === 'true' ? '' : 'none';
  }

  input.addEventListener('change', onChange);
  onChange();
}